import React from "react";
import "./FormVehicle.css";
import DropDown from "../dropdown/DropDown";
import InputField from "../inputfields/InputField";
import MultiSelectDropDown from "../dropdown/MultiSelectDropDown";
import { convertProperty } from "../../propertyconverter";

const fitmentOptions = [
    { label: "Tow Bar", value: "Tow Bar" },
    { label: "Canopy", value: "Canopy" },
    { label: "Roof Racks", value: "Roof Racks" },
    { label: "BullBar", value: "BullBar" },
];

function FormVehicleInfo({ nextStep, prevStep, formHeading, quote, vehicleList, addRemoveVehicle }) {
    const [vehType, setVehType] = React.useState("Vehicle Type");
    const [insurance, setInsurance] = React.useState("Insurance");
    const [vehCondition, setVehCondition] = React.useState("Vehicle Condition");
    const [makeModel, setMakeModel] = React.useState("");
    const [regNo, setRegNo] = React.useState("");
    const [fitments, setFitments] = React.useState([]);

    const [selectedFitments, setSelectedFitments] = React.useState([]);

    React.useEffect(() => {
        quote.vehicleType = vehType;
        quote.insuranceOption = insurance;
        quote.vehicleCondition = vehCondition;
        quote.makeModel = makeModel;
        quote.regNo = regNo;
        quote.fitments = fitments.join(", ");
    }, [vehType, insurance, vehCondition, makeModel, regNo, fitments]);

    // The multiselect only takes an object array, convert it into a string array
    function handleFitmentsChange(fitmentsObjArr) {
        var fArr = new Array();
        fitmentsObjArr.map((fitment) => {
            fArr.push(fitment.value);
        });
        setFitments(fArr);
        setSelectedFitments(fitmentsObjArr);
    }

    const initForNewVehicle = () => {
        console.log("init")
        setVehType("Vehicle Type");
        setInsurance("Insurance");
        setVehCondition("Vehicle Condition");
        setMakeModel("");
        setRegNo("");
        setFitments([]);
        setSelectedFitments([]);
    };

    // Manage the dropdowns active states
    const [isVehTypeActive, setVehTypeActive] = React.useState(false);
    const [isVehConditionActive, setVehConditionActive] = React.useState(false);
    const [isInsureActive, setInsureActive] = React.useState(false);

    const addVehicleToList = (quote) => {
        const vehicleToAdd = {
            vehicleType: convertProperty(quote.vehicleType),
            insuranceOption: convertProperty(quote.insuranceOption),
            vehicleCondition: convertProperty(quote.vehicleCondition),
            makeModel: quote.makeModel,
            regNo: quote.regNo,
            fitments: quote.fitments
        }
        addRemoveVehicle(vehicleToAdd, "add");
        initForNewVehicle();
    };

    return (
        <div className="formRouteMainContainer">
            <div className="formVehicleContainer">
                <div className="formVehicleHeader">
                    <div className="formVehicleHeaderContent">{formHeading}</div>
                </div>
                <div className="formVehicleContent">

                    <div className="formVehicleContent-row">
                        <div className="formVehicleContent-col">
                            <div className="formVehicleContent-row">
                                <div className="formVehicle-dropDowns">
                                    <InputField value={regNo} placeholder="Registration Number" onChangeValueSetter={setRegNo} />
                                </div>
                            </div>
                            <div className="formVehicleContent-row">
                                <div className="formVehicle-dropDowns">
                                    <InputField value={makeModel} placeholder="Make / Model" onChangeValueSetter={setMakeModel} />
                                </div>
                            </div>
                            <div className="formVehicleContent-row">
                                <div className="formVehicle-dropDowns">
                                    <DropDown selected={vehType} setSelected={setVehType} menuItems={["Sedan/Hatchback", "Bakkie", "SUV", "Minivan", "Exotic / Other"]}
                                        isActive={isVehTypeActive} setIsActive={setVehTypeActive} size="medium" />
                                </div>
                            </div>
                        </div>
                        <div className="formVehicleContent-col">
                            <div className="formVehicleContent-row">
                                <div className="formVehicle-dropDowns">
                                    <MultiSelectDropDown handleSelection={handleFitmentsChange} options={fitmentOptions} value={selectedFitments} />
                                </div>
                            </div>
                            <div className="formVehicleContent-row">
                                <div className="formVehicle-dropDowns">
                                    <DropDown selected={insurance} setSelected={setInsurance} menuItems={["I am covered", "Own risk (no cover)"]} isActive={isInsureActive}
                                        setIsActive={setInsureActive} size="medium" />
                                </div>
                            </div>
                            <div className="formVehicleContent-row">
                                <div className="formVehicle-dropDowns">
                                    <DropDown selected={vehCondition} setSelected={setVehCondition} menuItems={["Running", "Non-Running", "Require Forklift"]}
                                        isActive={isVehConditionActive} setIsActive={setVehConditionActive} size="medium" />
                                </div>
                            </div>
                            <div className="formVehicleContent-row">
                                <div className="formVehicle-add-vehicle" onClick={() => addVehicleToList(quote)}>
                                    <div className="counterValue">
                                        <h5>+</h5>
                                    </div>
                                    <div className="vehiclesDescription">
                                        <div className="special-text">Add Vehicle</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="buttonSpacer"></div>
                <div className="btn-container">
                    <button className="btn-prev" onClick={prevStep}>Previous</button>
                    <button className="btn-next" onClick={nextStep}>Overview</button>
                </div>
            </div>
        </div>
    );
}

export default FormVehicleInfo;
